import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { saveCachedVocabulary } from "@/util/vocabularyCache";

// Fetched on every page load (App.jsx): right after login and on each refresh.
// The rows are also cached in localStorage so labels render immediately on a
// refresh while the new copy is fetched.
export const fetchVocabulary = createAsyncThunk("vocabulary/fetchAll", async () => {
  const { data } = await api.get(API_ENDPOINTS.config.vocabulary.getAll);
  const rows = Array.isArray(data) ? data : [];
  saveCachedVocabulary(rows);
  return rows;
});
